import '@juvo/ui/tokens.css';
import './app-shell.js';

function isModifiedClick(event: MouseEvent) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
}

window.addEventListener(
  'click',
  (event) => {
    if (event.defaultPrevented || isModifiedClick(event)) return;
    const anchor = event
      .composedPath()
      .find((node): node is HTMLAnchorElement => node instanceof HTMLAnchorElement);
    if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${location.pathname}${location.search}${location.hash}`;
    if (next !== current) {
      history.pushState({}, '', next);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
  },
  true,
);
